import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Grid, Button } from '@material-ui/core'
//import Select from 'react-select';

import { permissionsGroupOrder, Appcues, PermissionsList } from '../../../utils/constants'

// actions
import { getShopList, updateShop } from '../../../actions/shop'
import {
  getAllPermissions,
  getPermissionsByCompany,
  updateRole,
  assignPermissions,
  saveNewRole,
} from '../../../actions/company'

// utils
import { isValidString } from '../../../utils/string'
import { hasAccess } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ModalDialog from '../../../components/common/ModalDialog'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import RolePermissions from '../../../components/RolePermissions'
import NewRole from '../../../components/RolePermissions/NewRole'
import { isFeatureFlagEnable } from '../../../api/unleash'
import { UnleashToggles } from '../../../types/unleashToggles'

const EXCLUDED_PERMISSION_KEY = 'iPadApplyRewards'

class RolesAndPermissions extends PureComponent {
  state = {
    NewShopName: '',
    role: {
      name: '',
      permissions: [],
    },
    applyRewardFF: false,
    canUseInsightsV2Permissions: false,
    canUseGlobalBroadcasts: false
  }

  async componentDidMount() {
    const featureFlags = [
      isFeatureFlagEnable(UnleashToggles.CAN_USE_RETAIL_INSIGHTS),
      isFeatureFlagEnable(UnleashToggles.CAN_USE_GLOBAL_BROADCASTS)
    ]
    const [canUseInsightsV2Permissions, canUseGlobalBroadcasts] = await Promise.all(featureFlags)
    this.setState({ 
      canUseInsightsV2Permissions: canUseInsightsV2Permissions,
      canUseGlobalBroadcasts: canUseGlobalBroadcasts
    })

    this.props.dispatch(getAllPermissions())
    this.props.dispatch(getPermissionsByCompany())
    this.checkApplyRewardFF()
  }

  onShopUpdate = (data, afterOnSave) => {
    this.props.dispatch(updateShop(data)).then((response) => {
      this.props.dispatch(getShopList())
      afterOnSave(response)
    })
  }

  onShopNameChange = (e) => {
    this.setState({
      NewShopName: e.target.value,
    })
  }

  openCreateRoleModal = () => {
    Appcues.track('Creating Role')
    this.createRoleModal.handleClickOpen()
  }

  closeCreateRoleModal = () => {
    this.setState({
      role: {
        name: '',
        permissions: [],
      },
    })
  }

  createRole = () => {
    const { role } = this.state

    const { name, permissions } = role

    this.checkValidBroadcastPermissions(permissions)

    if (!isValidString(name)) {
      this.props.dispatch(openErrorMessage('Please enter role name'))
      return false
    }

    this.props.dispatch(saveNewRole(role)).then((newRole) => {
      Appcues.track('New Role Created')
      this.props.dispatch(openSuccessMessage('Role created successfully'))
      this.createRoleModal.handleClose()
    })
  }

  checkValidBroadcastPermissions = (permissions) => {
    const broadcastPermissions = permissions.filter((permission) => permission === PermissionsList.Broadcast.WEB_EDIT_BROADCAST || PermissionsList.Broadcast.WEB_VIEW_BROADCAST)
    if (broadcastPermissions.length === 0) return

    const includesEditBroadcastsPermissions = broadcastPermissions.includes(PermissionsList.Broadcast.WEB_EDIT_BROADCAST)
    const includesViewBroadcastsPermissions = broadcastPermissions.includes(PermissionsList.Broadcast.WEB_VIEW_BROADCAST)
    if (includesEditBroadcastsPermissions  && !includesViewBroadcastsPermissions) {
      permissions.push(PermissionsList.Broadcast.WEB_VIEW_BROADCAST)
    }
  }

  setChange = (key, value) => {
    this.setState((prevState) => ({
      role: {
        ...prevState.role,
        [key]: value,
      },
    }))
  }

  onSave = (updatedRole, index) => {
    const { activeTab } = this.state
    const { session = {} } = this.props.authReducer
    const { employee = {} } = session || {}

    const { companyPermissions = [] } = this.props.companyReducer

    const role = companyPermissions[index].roles.find((role) => role.id === updatedRole.id)
    const disabledPermissions = role.permissions.filter(function (element) {
      return updatedRole.permissions.indexOf(element) === -1
    })

    const data = {
      roleId: updatedRole.id,
      appTarget: activeTab,
      enabledPermissions: updatedRole.permissions,
      disabledPermissions,
    }

    if (role.name !== updatedRole.name) {
      this.props.dispatch(updateRole(updatedRole)).then((res) => {
        return this.assignPermission(data, employee)
      })
    } else {
      return this.assignPermission(data, employee)
    }
  }

  assignPermission = (data, employee) => {
    return new Promise((resolve, reject) => {
      this.props.dispatch(assignPermissions(data)).then((res) => {
        this.props.dispatch(openSuccessMessage('The permissions have been updated successfully'))
        this.props
          .dispatch(getPermissionsByCompany())
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
        if (employee.role.id === data.roleId) {
          employee.role.permissions = data.enabledPermissions
          //this.props.dispatch(loginAction({...this.props.authReducer, employee}));
        }
      })
    })
  }

  checkApplyRewardFF = () => {
    isFeatureFlagEnable(UnleashToggles.APPLY_REWARD).then((res) =>
      this.setState({ applyRewardFF: res }),
    )
  }
  render() {
    /* const {
            shopsList = {}
        } = this.props.shopReducer; */

    const { companyPermissions = {}, permissions = [] } = this.props.companyReducer

    /* const {
            values = []
        } = shopsList; */

    const { role } = this.state

    let qtyIterate = 0

    //const terminalsValues = terminals.values || [];

    //const sortedShops = sortArrayByName(values)

    let groupedPermissions = {}
    let permissionsModified = [...permissions]

    if (!this.state.applyRewardFF) {
      permissionsModified = permissionsModified.filter(
        (permission) => permission.key !== EXCLUDED_PERMISSION_KEY,
      )
    }

    if (!this.state.canUseGlobalBroadcasts) {
      permissionsModified = permissionsModified.filter(
        (permission) => permission.group !== 'Broadcast',
      )
    }

    permissionsModified &&
      permissionsModified.length &&
      permissionsModified.forEach((permission) => {
        groupedPermissions[permission.group] = [
          ...(groupedPermissions[permission.group] || []),
          permission,
        ]
      })

    let updatedPermissions = []

    let permissionsGroupOrderFiltered = this.state.canUseInsightsV2Permissions 
      ? Array.from(permissionsGroupOrder)
      : permissionsGroupOrder.filter(permissionGroupOrder => permissionGroupOrder !=='InsightsV2')
    
    permissionsGroupOrderFiltered = this.state.canUseGlobalBroadcasts 
      ? Array.from(permissionsGroupOrderFiltered)
      : permissionsGroupOrderFiltered.filter(permissionGroupOrder => permissionGroupOrder !=='Broadcast')

    for (let key of permissionsGroupOrderFiltered) {
      updatedPermissions = [...updatedPermissions, ...(groupedPermissions[key] || [])]
    }

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {hasAccess() ? (
            <Button
              variant="raised"
              className="primary-button pull-right margin-bottom-small"
              onClick={this.openCreateRoleModal}
            >
              Create Role
            </Button>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {(companyPermissions &&
            companyPermissions.length &&
            companyPermissions.map((permission, index) => {
              if (
                (permission.appTarget === 'Retail' ||
                  permission.appTarget === 'Grow' ||
                  permission.appTarget === 'Distribution') &&
                qtyIterate < 1
              ) {
                qtyIterate++
                return (
                  <RolePermissions
                    key={index}
                    index={index}
                    roles={permission.roles}
                    permissions={updatedPermissions}
                    access_condition={''}
                    onSave={this.onSave}
                    canUseInsightsV2Permissions={this.state.canUseInsightsV2Permissions}
                    canUseGlobalBroadcasts={this.state.canUseGlobalBroadcasts}
                  />
                )
              } else {
                return null
              }
            })) ||
            null}
        </Grid>
        <ModalDialog
          title={'Create New Role'}
          ref={(c) => (this.createRoleModal = c)}
          onConfirm={this.createRole}
          onClose={this.closeCreateRoleModal}
          maxWidth="md"
          className="new_role_modal"
          paperStyle={{ 'overflow-y': 'initial' }}
        >
          <NewRole setChange={this.setChange} role={role} permissions={permissionsModified} />
        </ModalDialog>
      </Grid>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer, authReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
  authReducer,
}))(ContainerWithTitle(RolesAndPermissions, 'Granular Roles And Permissions'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/RolesAndPermissions.js